import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { key: 5 }
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  class: "modal fade createNewModal",
  id: "Image",
  tabindex: "-1",
  ref: "ImageRef",
  "aria-hidden": "true"
}
const _hoisted_19 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = { class: "modal-body pt-0 ps-0 pe-0 pb-0" }
const _hoisted_22 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "position-relative text-black fw-bold mb-10" }, "Informations générales", -1)),
              _createVNode(_component_router_link, {
                to: "/liste-abonnes",
                class: "btn btn-primary transition border-0 lh-1 fw-medium"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1),
                  _createElementVNode("span", { class: "position-relative" }, null, -1),
                  _createTextVNode("Retour", -1)
                ]))]),
                _: 1
              })
            ]),
            _createElementVNode("table", _hoisted_6, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[2] || (_cache[2] = _createElementVNode("td", null, "NOM & PRENOMS ou DENOMINATION", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.abonne?.nomComplet), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("td", null, "Pays de résidence", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.abonne?.nationalite), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("td", null, "Téléphone", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.abonne?.telephone), 1)
                ]),
                (_ctx.abonne?.dateNaissance)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                      (_ctx.abonne?.categorieAbonne?.id === 1)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_8, "Date de naissance"))
                        : (_openBlock(), _createElementBlock("td", _hoisted_9, "Date de création")),
                      _createElementVNode("td", null, _toDisplayString(_ctx.format_Date(_ctx.abonne.dateNaissance)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.abonne?.email)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                      _cache[5] || (_cache[5] = _createElementVNode("td", null, "Email", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.abonne?.email), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.abonne?.categorieAbonne)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                      (_ctx.abonne?.categorieAbonne?.id === 1)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_12, "Sexe"))
                        : _createCommentVNode("", true),
                      (_ctx.abonne?.categorieAbonne?.id === 1)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(_ctx.abonne?.sexe), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.abonne?.profession)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                      _cache[6] || (_cache[6] = _createElementVNode("td", null, "Profession", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.abonne?.profession), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.abonne?.adresseResidence)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                      _cache[7] || (_cache[7] = _createElementVNode("td", null, "Adresse de résidence", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.abonne?.adresseResidence), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.abonne?.villeResidence)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                      _cache[8] || (_cache[8] = _createElementVNode("td", null, "Ville de résidence", -1)),
                      _createElementVNode("td", null, _toDisplayString(_ctx.abonne?.villeResidence), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("td", null, "Catégorie de l'abonné", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.abonne?.categorieAbonne?.libelle), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("td", null, "Secteur d'activité", -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.abonne?.activite?.libelle), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[11] || (_cache[11] = _createElementVNode("td", null, "Image", -1)),
                  _createElementVNode("td", null, [
                    _createElementVNode("img", {
                      src: _ctx.getUrlApiForFiles('abonnes',_ctx.abonne?.urlImage),
                      alt: "Image",
                      width: "500",
                      height: "500"
                    }, null, 8, _hoisted_17)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                src: _ctx.image_,
                alt: ""
              }, null, 8, _hoisted_22)
            ])
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("button", {
            type: "button",
            class: "btn-close shadow-none",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ])
      ])
    ], 512)
  ], 64))
}